import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../../mutation-types';
import CrmCustomFieldDefinitionsAPI from '../../../api/crm/customFieldDefinitions';

export const state = {
    records: [],
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
    },
};

export const getters = {
    getUIFlags(_state) {
        return _state.uiFlags;
    },
    getCustomFieldDefinitions(_state) {
        return _state.records;
    },
    getDefinitionById: _state => id => {
        return _state.records.find(r => r.id === Number(id));
    },
    getDefinitionByApiKey: _state => apiKey => {
        return _state.records.find(r => r.api_key === apiKey);
    },
};

export const actions = {
    get: async ({ commit }) => {
        commit(types.SET_CRM_CUSTOM_FIELD_DEFS_UI_FLAG, { isFetching: true });
        try {
            const response = await CrmCustomFieldDefinitionsAPI.get();
            commit(types.SET_CRM_CUSTOM_FIELD_DEFS, response.data);
        } catch (error) {
            // Ignore
        } finally {
            commit(types.SET_CRM_CUSTOM_FIELD_DEFS_UI_FLAG, { isFetching: false });
        }
    },
    create: async ({ commit }, obj) => {
        commit(types.SET_CRM_CUSTOM_FIELD_DEFS_UI_FLAG, { isCreating: true });
        try {
            const response = await CrmCustomFieldDefinitionsAPI.create(obj);
            commit(types.ADD_CRM_CUSTOM_FIELD_DEF, response.data);
            return response.data;
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_CUSTOM_FIELD_DEFS_UI_FLAG, { isCreating: false });
        }
    },
    update: async ({ commit }, { id, ...updateObj }) => {
        commit(types.SET_CRM_CUSTOM_FIELD_DEFS_UI_FLAG, { isUpdating: true });
        try {
            const response = await CrmCustomFieldDefinitionsAPI.update(id, updateObj);
            commit(types.EDIT_CRM_CUSTOM_FIELD_DEF, response.data);
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_CUSTOM_FIELD_DEFS_UI_FLAG, { isUpdating: false });
        }
    },
    delete: async ({ commit }, id) => {
        commit(types.SET_CRM_CUSTOM_FIELD_DEFS_UI_FLAG, { isDeleting: true });
        try {
            await CrmCustomFieldDefinitionsAPI.delete(id);
            commit(types.DELETE_CRM_CUSTOM_FIELD_DEF, id);
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_CUSTOM_FIELD_DEFS_UI_FLAG, { isDeleting: false });
        }
    },
};

export const mutations = {
    [types.SET_CRM_CUSTOM_FIELD_DEFS_UI_FLAG](_state, data) {
        _state.uiFlags = { ..._state.uiFlags, ...data };
    },
    [types.SET_CRM_CUSTOM_FIELD_DEFS]: MutationHelpers.set,
    [types.ADD_CRM_CUSTOM_FIELD_DEF]: MutationHelpers.create,
    [types.EDIT_CRM_CUSTOM_FIELD_DEF]: MutationHelpers.update,
    [types.DELETE_CRM_CUSTOM_FIELD_DEF]: MutationHelpers.destroy,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
